import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PharmacyService } from 'src/app/services/pharmacy.service';
import { HomeService } from 'src/app/services/home.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/auth.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pharmacy-list',
  templateUrl: './pharmacy-list.component.html',
  styleUrls: ['./pharmacy-list.component.css']
})
export class PharmacyListComponent implements OnInit {
  cities: any = []
  pharmacyList: any = [];
  skip = 0;
  object: any = { city: localStorage.getItem('currentcity') ? localStorage.getItem('currentcity').toLowerCase() : '', name: '' }
  currentCity: String = localStorage.getItem('currentcity') ? localStorage.getItem('currentcity').toLowerCase() : ''
  @ViewChild('myScrollContainer') myScrollContainer: ElementRef;

  isBloodbank = false;
  searchText = 'Search pharmacy..';

  constructor(public pharmacySvc: PharmacyService, private router: Router,
    private homeSvc: HomeService,
    private spinner: NgxSpinnerService,
    private auth: AuthService) {
  }


  ngOnInit() {
    if (this.router.url.includes('blood')) {
      this.isBloodbank = true;
      this.searchText = 'Search blood bank..';
    }
    this.getCities()
    this.getLocation()
  }

  selectEvent(item, form: NgForm) {
    console.log(item)
    this.object.city = item
    console.log(this.object)
    // do something with selected item
    form.value.city = item
    this.skip = 0
    this.getPharmacyList(form)
  }

  onChangeSearch(val: string) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e) {
  }
  getCities() {
    let type = 'PHARMACY';
    if (this.isBloodbank) {
      type = 'BLOOD_BANK';
    }
    this.homeSvc.getCities(type).subscribe(res => {
      this.cities = res["data"]
      if (localStorage.getItem('currentcity')) {
        let arr = this.cities.filter(city => city.toLowerCase() == localStorage.getItem('currentcity').toLowerCase())
        // console.log(arr)
        if (arr.length == 0)
          this.cities.push(localStorage.getItem('currentcity'))
      }
    }, error => {

    })
  }
  getLocation() {
    this.auth.getLocation().then(location => {

      localStorage.setItem('lat', location.lat)
      localStorage.setItem('lng', location.lng)
      this.skip = 0
      let objectSearch = { value: { name: '', city: '' } }
      this.getPharmacyList(objectSearch)


    })
  }

  detectLocation(form: NgForm) {
    this.object.city = this.currentCity ? this.currentCity.toLowerCase() : ''
    //console.log(this.object)
    // do something with selected item
    form.value.city = this.currentCity ? this.currentCity.toLowerCase() : ''
    console.log(form.value)
    this.skip = 0
    this.getPharmacyList(form)
  }

  getPharmacyList(obj) {
    this.spinner.show()
    this.pharmacyList = []
    if (this.isBloodbank) {
      obj['type'] = 'BLOOD_BANK';
    } else {
      obj['type'] = 'PHARMECY';
    }
    obj['timeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.pharmacySvc.getPharmacyList(this.skip, obj).subscribe(res => {
      // this.pharmacyList = res["data"];
      if(this.skip == 0) {
        this.pharmacyList = [];
      }
      res["data"].forEach((val) => {
        this.pharmacyList.push(val);
      })
      this.spinner.hide()
    }, error => {
      console.log(error);
    })
  }

  searchDoctorForm(form: NgForm) {
    this.skip = 0
    this.getPharmacyList(form)
  }

  isNoData = false;

  getPharmacyListScroll(obj) {
    this.isNoData = false;
    this.spinner.show()

    this.pharmacySvc.getPharmacyList(this.skip, obj).subscribe(res => {
      // this.pharmacyList = res["data"];
      if(res["data"] && !res["data"].length) {
        this.isNoData = true;
      }
      res["data"].forEach((val) => {
        this.pharmacyList.push(val);
      })
      this.spinner.hide()
    }, error => {
      console.log(error);
    })
  }

  onScroll(form: NgForm) {
    this.skip = this.skip + 1

    if(!this.isNoData) {
      this.getPharmacyListScroll(form);
    }
    console.log('am in on sfcerrol');
  }

}
